import React from "react";
import { Box, Typography, Grid, useTheme, useMediaQuery } from "@mui/material";

const stats = [
  {
    value: (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography
          fontSize={{ xs: "24px", sm: "28px" }}
          color="#000"
          fontWeight={600}
        >
          10K+
        </Typography>
        <Typography color="transparent" fontWeight={500} fontSize="25px">
          million
        </Typography>
      </Box>
    ),
    label: "Clients from over 110 countries",
  },
  {
    value: (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography
          fontSize={{ xs: "24px", sm: "28px" }}
          color="#000"
          fontWeight={600}
        >
          2<span style={{ color: "#2494C9" }}>+</span>
        </Typography>
        <Typography color="#000" fontWeight={600} fontSize="25px">
          million
        </Typography>
      </Box>
    ),
    label: "Trades executed with zero request of rejections",
  },
  {
    value: (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography
          fontSize={{ xs: "24px", sm: "28px" }}
          color="#000"
          fontWeight={600}
        >
          3<span style={{ color: "#2494C9" }}>+</span>
        </Typography>
        <Typography color="#000" fontWeight={600} fontSize="25px">
          Languages
        </Typography>
      </Box>
    ),
    label: "Award-winning Customer Experience team",
  },
];

const SecondCard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        mx: "auto",
        px: { xs: 2, sm: 3, md: 9 },
        py: { xs: 3, sm: 1 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      {isMobile ? (
        // 📱 Mobile view
        <Box
          sx={{
            width: "100%",
            maxWidth: 500,
            background: "#f4f4f4",
            borderRadius: "20px",
            px: 2,
            py: 4,
          }}
        >
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignContent="center"
          >
            {stats.map((stat, index) => (
              <Grid item xs={12} key={index}>
                <Box textAlign="center">
                  {stat.value}
                  <Typography
                    sx={{
                      mt: 1.2,
                      color: "rgba(102, 112, 133, 1)",
                      fontWeight: 500,
                      fontSize: "0.95rem",
                      fontFamily: "SF Pro Display",
                      mx: "auto",
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        // 💻 Desktop / Tablet view
        <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 1750,
          backgroundImage: 'url("/Images/SHADOW.png")',
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          borderRadius: "20px",
          overflow: "hidden",
          minHeight: {
            xs: "auto",
            md: "240px",
            lg: "300px",
            xl: "340px",
          },
          mx: "auto", // Optional: center horizontally in page
        }}
      >
        {/* 👇 Absolute positioned wrapper to center content */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 2, md: 6 },
            pb: { xs: 4, md: 6 },   // padding-top: 32px (xs), 48px (md)
            pt: 0, 
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row", // Always row
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap", // Optional wrap for smaller screens
              gap: { xs: 3, md: 4 },
              width: "100%",
            }}
          >
            {stats.map((stat, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  borderRight:
                    index < stats.length - 1
                      ? "1px solid rgba(0,0,0,0.1)"
                      : "none",
                  px: { xs: 1, md: 3 },
                  flex: { xs: "1 1 100%", sm: "1 1 30%" },
                  maxWidth: { sm: "calc(33.33% - 24px)" },
                }}
              >
                {stat.value}
                <Typography
                  sx={{
                    mt: 1.5,
                    color: "rgba(102, 112, 133, 1)",
                    fontWeight: 500,
                    fontSize: { xs: "0.95rem", md: "1rem", lg: "1.1rem" },
                    fontFamily: "SF Pro Display",
                    maxWidth: 240,
                  }}
                >
                  {stat.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      
      )}
    </Box>
  );
};

export default SecondCard;
